import React from 'react';
import { imagery } from '../theme';

export function BrandLogo({
  size = 220,
  title = 'Black-Ops Luxury Car Service',
  className,
  style,
  src,
}) {
  const width = size;
  const height = Math.round(size / imagery.brandLogoAspect);
  return (
    <img
      src={src ?? imagery.brandLogoUrl}
      alt={title}
      width={width}
      height={height}
      data-testid="brand-logo"
      className={className}
      style={{
        display: 'inline-block',
        width,
        height,
        background: 'transparent',
        objectFit: 'contain',
        userSelect: 'none',
        ...style,
      }}
      draggable={false}
    />
  );
}
